import { defineComponent } from "vue";

export const ConfigMixin = defineComponent({
  methods: {
    getPdfWorkerSrc(version: string): string {
      return `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${version}/pdf.worker.mjs`;
    },
  },
});
